var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-travel" }, [
    _c("h1", { domProps: { textContent: _vm._s(_vm.translations.header) } }),
    _vm._v(" "),
    _c("h2", {
      domProps: { textContent: _vm._s(_vm.translations.offerHeader) }
    }),
    _vm._v(" "),
    _c("p", { domProps: { innerHTML: _vm._s(_vm.translations.offerText) } }),
    _vm._v(" "),
    _c("h2", {
      domProps: { textContent: _vm._s(_vm.translations.formHelpHeader) }
    }),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm.success
      ? _c(
          "div",
          { staticClass: "group-travel-form" },
          [
            _c("msg-block", { attrs: { type: "success" } }, [
              _c("span", {
                domProps: { textContent: _vm._s(_vm.translations.successMsg) }
              })
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.success
      ? _c(
          "div",
          { staticClass: "group-travel-form" },
          [
            _c("h1", {
              domProps: { textContent: _vm._s(_vm.translations.formHeader) }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "booking-block" },
              [
                _c("search-destination", {
                  attrs: {
                    "show-selector": _vm.showSelector,
                    "open-modal": _vm.openModal,
                    "empty-on-select": true,
                    disabled: _vm.destinations.length >= 2
                  },
                  on: {
                    hide: function($event) {
                      _vm.showSelector = null
                    },
                    show: function($event) {
                      _vm.showSelector = "destination-selector"
                    }
                  },
                  model: {
                    value: _vm.selectedDestinationAirport,
                    callback: function($$v) {
                      _vm.selectedDestinationAirport = $$v
                    },
                    expression: "selectedDestinationAirport"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "group-travel__destinations" }, [
                  _c("h3", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.input.destinations)
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.destinations, function(destination) {
                      return _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.removeDestination(destination)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(destination.name) +
                              "\n                        "
                          ),
                          _vm._m(1, true)
                        ]
                      )
                    })
                  )
                ]),
                _vm._v(" "),
                _vm.errors.destinations
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _vm.errors.destinations
                        ? _c("span", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.destinations[0])
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "booking-block" }, [
              _c("div", { staticClass: "group-travel__flex" }, [
                _c(
                  "div",
                  { staticClass: "group-travel__flex__item" },
                  [
                    _c("date-picker", {
                      attrs: {
                        name: _vm.translations.input.travelFromDate,
                        "default-date": _vm.groupData.fromdate,
                        "is-ready": true,
                        "start-from": _vm.startDate.format("DD-MM-YYYY"),
                        "end-at": _vm.groupData.todate,
                        format: "DD-MM-YYYY"
                      },
                      on: {
                        pickdate: function(date) {
                          return (_vm.groupData.fromdate = date)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.fromdate
                      ? _c("msg-block", { attrs: { type: "error" } }, [
                          _vm.errors.fromdate
                            ? _c("span", [
                                _c("b", {
                                  domProps: {
                                    textContent: _vm._s(_vm.errors.fromdate[0])
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "group-travel__flex__item" },
                  [
                    _c("date-picker", {
                      attrs: {
                        name: _vm.translations.input.travelToDate,
                        "default-date": _vm.groupData.todate,
                        "is-ready": true,
                        "start-from":
                          _vm.groupData.fromdate ||
                          _vm.startDate.format("DD-MM-YYYY"),
                        format: "DD-MM-YYYY"
                      },
                      on: {
                        pickdate: function(date) {
                          return (_vm.groupData.todate = date)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.todate
                      ? _c("msg-block", { attrs: { type: "error" } }, [
                          _vm.errors.todate
                            ? _c("span", [
                                _c("b", {
                                  domProps: {
                                    textContent: _vm._s(_vm.errors.todate[0])
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("h3", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.input.travelTime)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "label-input booking-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.groupData.duration,
                            expression: "groupData.duration"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.groupData,
                              "duration",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", {
                          domProps: {
                            value: 0,
                            textContent: _vm._s(
                              _vm.translations.input.selectTravelTime
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("option", {
                          attrs: { value: "exact" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.input.selectedTravelTimeDates
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(42, function(n) {
                          return _c("option", { domProps: { value: n } }, [
                            _vm._v(
                              _vm._s(n) +
                                " " +
                                _vm._s(
                                  n < 1
                                    ? _vm.translations.input.day
                                    : _vm.translations.input.days
                                )
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c("option", {
                          attrs: { value: "6weeksplus" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.input.moreThen6Weeks
                            )
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        staticClass: "icon-dropdown",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 395.65 223"
                        }
                      },
                      [
                        _c("path", {
                          staticStyle: { fill: "rgb(140, 140, 130)" },
                          attrs: {
                            d:
                              "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.errors.duration
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.duration
                          ? _c("span", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.duration[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "group-travel__budget" },
              [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.input.price)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.input.budgetHelp)
                  }
                }),
                _vm._v(" "),
                _c("p", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.input.budgetInfo)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("vue-slider", {
                  staticClass: "group-travel-slider",
                  attrs: { min: 0, max: 250000, tooltip: false, interval: 500 },
                  model: {
                    value: _vm.groupData.budget,
                    callback: function($$v) {
                      _vm.$set(_vm.groupData, "budget", $$v)
                    },
                    expression: "groupData.budget"
                  }
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.translations.input.choosenBudget) + " "),
                  _vm.groupData.budget
                    ? _c("span", [
                        _c("span", {
                          directives: [
                            {
                              name: "price",
                              rawName: "v-price",
                              value: _vm.groupData.budget,
                              expression: "groupData.budget"
                            }
                          ]
                        }),
                        _vm._v(",- DKK")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.groupData.budget
                    ? _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.translations.input.noBudget)
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.errors.budget
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _vm.errors.budget
                        ? _c("span", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.budget[0])
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "booking-block booking-block--no-margin" },
              [
                _c(
                  "div",
                  { staticClass: "group-travel__hotel-stars" },
                  [
                    _c("h3", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.translations.input.hotelCategories
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "group-travel__checkboxes" }, [
                      _c(
                        "div",
                        { staticClass: "group-travel__checkboxes__item" },
                        [
                          _c("checkbox", {
                            attrs: {
                              name: "2 " + _vm.translations.input.stars,
                              value: _vm.groupData.kategori.indexOf(2) > -1
                            },
                            on: {
                              checked: function(checked) {
                                return _vm.setCategories(2, checked)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "group-travel__checkboxes__item" },
                        [
                          _c("checkbox", {
                            attrs: {
                              name: "3 " + _vm.translations.input.stars,
                              value: _vm.groupData.kategori.indexOf(3) > -1
                            },
                            on: {
                              checked: function(checked) {
                                return _vm.setCategories(3, checked)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "group-travel__checkboxes__item" },
                        [
                          _c("checkbox", {
                            attrs: {
                              name: "4 " + _vm.translations.input.stars,
                              value: _vm.groupData.kategori.indexOf(4) > -1
                            },
                            on: {
                              checked: function(checked) {
                                return _vm.setCategories(4, checked)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "group-travel__checkboxes__item" },
                        [
                          _c("checkbox", {
                            attrs: {
                              name: "5 " + _vm.translations.input.stars,
                              value: _vm.groupData.kategori.indexOf(5) > -1
                            },
                            on: {
                              checked: function(checked) {
                                return _vm.setCategories(5, checked)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.kategori
                      ? _c("msg-block", { attrs: { type: "error" } }, [
                          _vm.errors.kategori
                            ? _c("span", [
                                _c("b", {
                                  domProps: {
                                    textContent: _vm._s(_vm.errors.kategori[0])
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "booking-block booking-block--no-margin" },
              [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.input.roomType)
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.translations.input.roomTypes, function(
                  roomType,
                  roomTypeKey
                ) {
                  return _c(
                    "div",
                    { staticClass: "group-travel__room-checkbox" },
                    [
                      _c("checkbox", {
                        attrs: {
                          name: roomType.name,
                          value: _vm.selectedRoomTypes[roomType.value]
                            ? true
                            : false
                        },
                        on: {
                          checked: function(checked) {
                            return _vm.setRoomType(roomType, checked)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--help",
                          on: {
                            click: function($event) {
                              _vm.showRoomHelpTxt = roomTypeKey
                            }
                          }
                        },
                        [_vm._v("?")]
                      ),
                      _vm._v(" "),
                      (_vm.selectedRoomTypes[roomType.value]
                      ? true
                      : false)
                        ? _c(
                            "div",
                            { staticClass: "label-input booking-field" },
                            [
                              _c(
                                "select",
                                {
                                  domProps: {
                                    value:
                                      _vm.selectedRoomTypes[roomType.value]
                                        .rooms.length
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setRoomTypeCount(
                                        roomType.value,
                                        $event.target.value
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", {
                                    domProps: {
                                      value: 0,
                                      textContent: _vm._s(
                                        _vm.translations.input.roomCount
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(10, function(n) {
                                    return _c(
                                      "option",
                                      { domProps: { value: n } },
                                      [_vm._v(_vm._s(n))]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "svg",
                                {
                                  staticClass: "icon-dropdown",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 395.65 223"
                                  }
                                },
                                [
                                  _c("path", {
                                    staticStyle: { fill: "rgb(140, 140, 130)" },
                                    attrs: {
                                      d:
                                        "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.showRoomHelpTxt !== null
                  ? _c("msg-block", { attrs: { type: "info" } }, [
                      _c("span", [
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.input.roomTypes[
                                _vm.showRoomHelpTxt
                              ].name
                            )
                          }
                        }),
                        _vm._v(
                          ": " +
                            _vm._s(
                              _vm.translations.input.roomTypes[
                                _vm.showRoomHelpTxt
                              ].helpTxt
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.translations.input.roomWarning)
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errors.roomtype || _vm.errors.roomcount
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _vm.errors.roomtype
                        ? _c("span", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.roomtype[0])
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.roomcount
                        ? _c("span", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.roomcount[0])
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "booking-block booking-block--no-margin" },
              [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.input.roomType)
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.selectedRoomTypes, function(
                  selectedRoomType,
                  selectedRoomTypeKey
                ) {
                  return _c(
                    "div",
                    { key: "roomtypekey_" + selectedRoomTypeKey },
                    _vm._l(selectedRoomType.rooms, function(room, key) {
                      return _c(
                        "div",
                        { key: "room_" + key },
                        [
                          _c("roomdata", {
                            attrs: {
                              roomTypeName:
                                selectedRoomType.name + " " + (key + 1),
                              value: room
                            },
                            on: {
                              input: function($value) {
                                return _vm.setRoomData(
                                  selectedRoomTypeKey,
                                  key,
                                  $value
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  )
                }),
                _vm._v(" "),
                _vm.errors.childage
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _vm.errors.childage
                        ? _c("span", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.childage[0])
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errors.adults
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _vm.errors.adults
                        ? _c("span", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.adults[0])
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "booking-block booking-block--no-margin group-travel__food"
              },
              [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.input.pensionTxt)
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label-input booking-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.groupData.pension,
                          expression: "groupData.pension"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.groupData,
                            "pension",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.translations.input.pension, function(
                      txt,
                      value
                    ) {
                      return _c("option", {
                        domProps: { value: value, textContent: _vm._s(txt) }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "icon-dropdown",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 395.65 223"
                      }
                    },
                    [
                      _c("path", {
                        staticStyle: { fill: "rgb(140, 140, 130)" },
                        attrs: {
                          d:
                            "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                        }
                      })
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "booking-block booking-block--no-margin group-travel__comments"
              },
              [
                _c("input-field", {
                  attrs: {
                    name: _vm.translations.input.comments,
                    "input-type": "textarea",
                    value: _vm.groupData.comments
                  },
                  on: {
                    input: function(val) {
                      return (_vm.groupData.comments = val)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "booking-block booking-block--no-margin" },
              [
                _c("div", { staticClass: "booking-block__content" }, [
                  _c("div", { staticClass: "input-fields" }, [
                    _c("h3", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.translations.input.contactperson_header
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-fields__content" }, [
                      _c("div", { staticClass: "label-input booking-field" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.groupData.title,
                                expression: "groupData.title"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.groupData,
                                  "title",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          _vm._l(_vm.translations.input.sexOptions, function(
                            txt,
                            value
                          ) {
                            return _c("option", {
                              domProps: {
                                value: value,
                                textContent: _vm._s(txt)
                              }
                            })
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "icon-dropdown",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 395.65 223"
                            }
                          },
                          [
                            _c("path", {
                              staticStyle: { fill: "rgb(140, 140, 130)" },
                              attrs: {
                                d:
                                  "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields" },
                    [
                      _c(
                        "div",
                        { staticClass: "input-fields__content" },
                        [
                          _c("input-field", {
                            staticClass:
                              "booking-field booking-field--firstname",
                            attrs: {
                              name: _vm.translations.input.firstName,
                              value: _vm.groupData.firstname,
                              "icon-type": !_vm.groupData.firstname
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.firstname = inp)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input-field", {
                            staticClass:
                              "booking-field booking-field--lastname",
                            attrs: {
                              name: _vm.translations.input.lastName,
                              value: _vm.groupData.lastname,
                              "icon-type": !_vm.groupData.lastname
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.lastname = inp)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors.firstname || _vm.errors.lastname
                        ? _c("msg-block", { attrs: { type: "error" } }, [
                            _vm.errors.firstname
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.errors.firstname[0]
                                      )
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.lastname
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.errors.lastname[0]
                                      )
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields" },
                    [
                      _c(
                        "div",
                        { staticClass: "input-fields__content" },
                        [
                          _c("input-field", {
                            staticClass: "booking-field booking-field--address",
                            attrs: {
                              name: _vm.translations.input.address,
                              value: _vm.groupData.address,
                              "icon-type": !_vm.groupData.address
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.address = inp)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors.address
                        ? _c("msg-block", { attrs: { type: "error" } }, [
                            _vm.errors.address
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(_vm.errors.address[0])
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields" },
                    [
                      _c(
                        "div",
                        { staticClass: "input-fields__content" },
                        [
                          _c("input-field", {
                            staticClass: "booking-field booking-field--zipcode",
                            attrs: {
                              name: _vm.translations.input.postal,
                              "input-type": "tel",
                              mask: "9999",
                              value: _vm.groupData.zipcode,
                              "icon-type": !_vm.groupData.zipcode
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.zipcode = inp.substr(
                                  0,
                                  4
                                ))
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input-field", {
                            staticClass: "booking-field booking-field--city",
                            attrs: {
                              name: _vm.translations.input.town,
                              value: _vm.groupData.city,
                              "icon-type": !_vm.groupData.city
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.city = inp)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors.zipcode || _vm.errors.city
                        ? _c("msg-block", { attrs: { type: "error" } }, [
                            _vm.errors.zipcode
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(_vm.errors.zipcode[0])
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.city
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(_vm.errors.city[0])
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields" },
                    [
                      _c(
                        "div",
                        { staticClass: "input-fields__content" },
                        [
                          _c("input-field", {
                            staticClass: "booking-field booking-field--phone",
                            attrs: {
                              name: _vm.translations.input.phone,
                              "input-type": "tel",
                              value: _vm.groupData.phone,
                              "icon-type": !_vm.groupData.phone
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.phone = inp)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors.phone
                        ? _c("msg-block", { attrs: { type: "error" } }, [
                            _vm.errors.phone
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(_vm.errors.phone[0])
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields" },
                    [
                      _c(
                        "div",
                        { staticClass: "input-fields__content" },
                        [
                          _c("input-field", {
                            staticClass: "booking-field booking-field--mail",
                            attrs: {
                              name: _vm.translations.input.email,
                              "input-type": "email",
                              value: _vm.groupData.email,
                              "icon-type": !_vm.groupData.email
                                ? ""
                                : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.email = inp)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input-field", {
                            staticClass:
                              "booking-field booking-field--mailconfirm",
                            attrs: {
                              name: _vm.translations.input.email_confirm,
                              "input-type": "email",
                              value: _vm.groupData.emailconfirm,
                              "icon-type":
                                _vm.groupData.emailconfirm !==
                                _vm.groupData.email
                                  ? ""
                                  : this.checkmarkIcon
                            },
                            on: {
                              input: function(inp) {
                                return (this$1.groupData.emailconfirm = inp)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors.email || _vm.errors.email_confirm
                        ? _c("msg-block", { attrs: { type: "error" } }, [
                            _vm.errors.email
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(_vm.errors.email[0])
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.email_confirm
                              ? _c("span", [
                                  _c("b", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.errors.email_confirm[0]
                                      )
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("checkbox", {
                  attrs: {
                    name: _vm.translations.input.newsletter,
                    value: _vm.groupData["contact-newsletter"]
                  },
                  on: {
                    checked: function(checked) {
                      return (_vm.groupData["contact-newsletter"] = checked)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn btn--submit",
              class: { "item-loading": _vm.loading },
              attrs: { disabled: _vm.loading },
              domProps: { textContent: _vm._s(_vm.translations.input.submit) },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.submit($event)
                }
              }
            }),
            _vm._v(" "),
            _vm.hasErrors
              ? _c("msg-block", { attrs: { type: "error" } }, [
                  !_vm.errors.submiterror
                    ? _c("span", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.ERRORS.hasErrors
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.submiterror
                    ? _c("span", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(_vm.errors.submiterror[0])
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-travel__illustrations" }, [
      _c(
        "div",
        {
          staticClass:
            "group-travel__illustrations__item group-travel__illustrations__item--adults"
        },
        [
          _c("span", [_vm._v("5 voksne (eller flere)")]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../../../assets/img/icons/group-travel-adults.svg")
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "group-travel__illustrations__item group-travel__illustrations__item--children"
        },
        [
          _c("span", [_vm._v("5 børn (eller flere)")]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../../../assets/img/icons/group-travel-children.svg")
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "group-travel__illustrations__item group-travel__illustrations__item--houses"
        },
        [
          _c("span", [_vm._v("2 boligenheder (eller flere)")]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../../../assets/img/icons/group-travel-houses.svg")
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/icons/icon-delete.svg"),
          alt: "Fjern"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-travel__recpapcha-text" }, [
      _c("p", [
        _vm._v("This site is protected by reCAPTCHA and the Google "),
        _c("a", { attrs: { href: "https://policies.google.com/privacy" } }, [
          _vm._v("Privacy Policy")
        ]),
        _vm._v(" and "),
        _c("a", { attrs: { href: "https://policies.google.com/terms" } }, [
          _vm._v("Terms of Service")
        ]),
        _vm._v(" apply.")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eecead78", { render: render, staticRenderFns: staticRenderFns })
  }
}